import axios from '../config/axios';

const obtenerUsuario = async email => await axios.post('/usuarios/interno/api/v1/existe', { usuarioId: email }).then(res => res.data).catch(err => err);


export {
  obtenerUsuario,
};



// WEBPACK FOOTER //
// ./src/apiService/request/Usuarios.js